// Colour by SERVICE FAMILY. A stop chip's left edge says what kind of work it is
// before anyone reads it: general pest, termite, mosquito, lawn, wildlife, bed bug,
// inspection — or for events and crews, the kind of booking or job. The family is
// read off the service name / code, so a tenant's own catalogue needs no mapping.
// Colours come from the route palette already in utils (stable index per family),
// never a new literal.
import { ROUTE_PALETTE } from "./utils";

const FAMILIES = [
  { key: "termite", label: "Termite", test: /termite|wdo|sentricon|bait station/i, color: 4 },
  { key: "mosquito", label: "Mosquito", test: /mosquito|in2care|misting/i, color: 5 },
  { key: "lawn", label: "Lawn & shrub", test: /lawn|turf|shrub|fert|weed|ornamental|palm/i, color: 1 },
  { key: "wildlife", label: "Wildlife & rodent", test: /rodent|wildlife|rat|mice|mouse|trap|exclusion|raccoon|squirrel/i, color: 2 },
  { key: "bedbug", label: "Bed bug", test: /bed ?bug|heat treat/i, color: 6 },
  { key: "inspection", label: "Inspection", test: /inspect|estimate|quote|walk ?through|site visit/i, color: 3 },
  { key: "install", label: "Install & build", test: /install|build|construct|hardscape|pavers|sod/i, color: 7 },
  { key: "maintenance", label: "Maintenance", test: /mow|maint|clean ?up|trim|edge|blow|prune/i, color: 1 },
  { key: "booking", label: "Booking", test: /wedding|reception|party|event|banquet|rental|venue/i, color: 6 },
  { key: "hold", label: "Hold", test: /hold|tentative/i, color: 3 },
  { key: "general", label: "General pest", test: /gpc|general|quarterly|monthly|bi-?monthly|pest|perimeter|interior|service/i, color: 0 },
];

export function serviceFamily(nameOrCode = "", code = "") {
  const hay = `${nameOrCode} ${code}`;
  const fam = FAMILIES.find((f) => f.test.test(hay)) || { key: "other", label: "Other", color: 7 };
  return { key: fam.key, label: fam.label, color: ROUTE_PALETTE[fam.color % ROUTE_PALETTE.length] };
}

/** The families present on a board, for the legend. */
export function familiesOn(stops = []) {
  const seen = new Map();
  stops.forEach((s) => {
    const f = serviceFamily(s.serviceName, s.serviceCode);
    if (!seen.has(f.key)) seen.set(f.key, { ...f, count: 0 });
    seen.get(f.key).count += 1;
  });
  return [...seen.values()].sort((a, b) => b.count - a.count);
}
